import type {FC, ReactNode} from 'react';
import styled from 'styled-components';

const LogoStyleWrapper = styled.div<{$width: string}>`
    margin: 1.5rem 0 0 0;

    img {
        width: ${({$width}) => $width};
        height: auto;
    }
`;

const Logo: FC<{iconWidth: string; children: ReactNode}> = ({iconWidth, children}) => {
    return <LogoStyleWrapper $width={iconWidth}>{children}</LogoStyleWrapper>;
};

export default Logo;
